import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getPseudonyms = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.pseudonym.pseudonyms.entries, filter);
};
